import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import Footer from "./footer";

function ScholarshipDetails() {
    const location = useLocation();
    const navigate = useNavigate();

    const scholarship = location.state?.scholarship;

    if (!scholarship) {
        return (
            <div className="container py-5 text-center">
                <h4>Scholarship not found</h4>
            </div>
        );
    }

    return (
        <div className="scholarship-details-page">

            {/* Breadcrumb */}
            <div className="sd-breadcrumb">
                <span onClick={() => navigate("/")}>Home</span>
                <FaAngleRight />
                <span onClick={() => navigate("/scholarship-index")}>Question and Answer</span>
                <FaAngleRight />
                <span className="spanhjeade-st">{scholarship.title}</span>
            </div>

            <div className="sd-wrapper">

                {/* Header */}
                <div className="sd-header">
                    <h5 className="scholar-titlest">{scholarship.title}</h5>
                </div>

                {/* Content */}
                <div className="sd-content">

                    {/* About */}
                    <div className="sd-section">
                        <h2>About (Brief description)</h2>

                        <div
                            dangerouslySetInnerHTML={{
                                __html: scholarship.description || "",
                            }}
                        />
                    </div>

                    {/* Eligibility */}
                    {scholarship.eligibility && (
                        <div className="sd-section">
                            <h2>Eligibility</h2>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: scholarship.eligibility,
                                }}
                            />
                        </div>
                    )}

                    {/* Contact Details */}
                    {scholarship.contact_details && (
                        <div className="sd-section">
                            <h2>Contact Details</h2>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: scholarship.contact_details,
                                }}
                            />
                        </div>
                    )}

                    {scholarship.more && (
                        <div className="sd-section">
                            <h2>More</h2>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: scholarship.more,
                                }}
                            />
                        </div>
                    )}

                    <button
                        className="sd-back-btn"
                        onClick={() => navigate("/scholarship-index")}
                    >
                        ← Back to Scholarships
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default ScholarshipDetails;